import { Component, OnInit } from '@angular/core';
import { CreateService } from '../services/create.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LICENSE_TYPE_OPTIONS, PERM_TYPE, ROLE_OPTIONS } from '../constants/dropdown.constants';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit{

  isViewEdit: boolean = false;
  viewEditObj: any;
  title: string = '';
  userForm: any;
  licenseTypeOptions = LICENSE_TYPE_OPTIONS ;
  roleOptions = ROLE_OPTIONS;
  permType = PERM_TYPE;
  reqRoleOptions: any;
  buttonText: string ='';

  constructor(private createService: CreateService, private fb: FormBuilder,
    private toastr: ToastrService, private router:Router){
    this.createService.getIsViewEdit().subscribe((res) => {
      this.isViewEdit = res;
    });
    this.createService.getViewEditObj().subscribe((res) => {
      this.viewEditObj = res;
    });
  }
  ngOnInit(): void {
    this.userForm = this.fb.group({ 
      driveId: ['', Validators.required],
      driveName: [''],
      licenseType: ['', Validators.required],
      permType: ['', ],
      role: ['',Validators.required],
      userEmail: ['', [Validators.required, Validators.email]],
      userName: [''],
    });
    if(this.isViewEdit){

      this.title = 'Edit User Access';
      this.buttonText = 'Edit';
      this.viewEditObj.licenseType = this.viewEditObj.licenseType? this.viewEditObj.licenseType : 'Frontline Starter';
      this.setUserData(this.viewEditObj);
    }else{

      console.log("Inside Add User");
      this.title = 'Add User Access';
      this.buttonText = 'Add';
    }

    // this.userForm.get('licenseType')?.valueChanges.subscribe((value: any)=>{
    //   if(value){
    //     this.userForm.get('role')?.enable();
    //   }else{
    //     this.userForm.get('role')?.disable();
    //   }
    // })
  }

  setUserData(obj:any){

    this.selectRole(obj.licenseType);

    this.userForm.setValue({
      driveId: obj.driveId,
      driveName: obj.driveName,
      licenseType: obj.licenseType,
      permType: obj.permType,
      role: obj.role,
      userEmail: obj.userEmail,
      userName: obj.userName
    });

    ['driveId', 'userEmail'].forEach(field => {
      this.userForm.get(field).disable();
    });
  }

  selectRole(event:any){
   // console.log(event.value);
   let licenseType: string;
   if(event.value == undefined){
    licenseType = event;
   }else{
    licenseType= event.value;
   }
    this.reqRoleOptions =this.roleOptions[licenseType];

  }

  submit(){
    var userData;
    if(!this.userForm.invalid){
      if(this.isViewEdit){
        userData={
         driveId: this.userForm.get('driveId').value,
         driveName: this.userForm.get('driveName').value,
         id: this.viewEditObj.id,
         licenseType: this.userForm.get('licenseType').value,
         permType: this.userForm.get('permType').value,
         role: this.userForm.get('role').value,
         userEmail: this.userForm.get('userEmail').value,
         userName: this.userForm.get('userName').value,
       }
       this.editUser(userData);
     }else{
        userData ={
         driveId: this.userForm.get('driveId').value,
         driveName: this.userForm.get('driveName').value,
         licenseType: this.userForm.get('licenseType').value,
         permType: this.userForm.get('permType').value,
         role: this.userForm.get('role').value,
         userEmail: this.userForm.get('userEmail').value,
         userName: this.userForm.get('userName').value,
       }

       this.saveUser(userData);
     }
    }
  }

  saveUser(userData:any){
    this.createService.saveUser(userData).subscribe({
      next: (userData: any) => {
        if (userData ) {
          this.toastr.success("User Added Successfully");
        } 
      },
      error: (e: any) => {
        if(e.status = 409){
          this.toastr.error(e.error);
        }else{
          this.toastr.error("Error while Adding User data");
        }  
      }
    })
  }

  editUser(userData:any){
    this.createService.updateUser(userData).subscribe({
      next: (userData: any) => {
        if (userData ) {
         this.toastr.success("User Updated Successfully");
        } 
      },
      error: (e: any) => {
        this.toastr.error("Error while updating User data");
      }
    })
  }

  cancel(){
    this.router.navigate(['access-request']);
  }
}
